import { Component, Inject, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, Product, ProductService, moneyMaskOutput } from 'lib-trend-core';
import { Validators } from 'ngx-editor';

@Component({
    selector: 'app-product-quick-form',
    templateUrl: './product-quick-form.component.html',
    styleUrl: './product-quick-form.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductQuickFormComponent extends AbstractComponent {
  /** ngx-mask hands the money inputs a string; the model keeps a number. */
  protected readonly moneyMaskOutput = moneyMaskOutput;

  public product: Product;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<ProductQuickFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Product,
    private productService: ProductService,
  ) {
    super(injector);
    this.setupForm();
  }

  private setupForm(): void {
    this.formGroup = this.formBuilder.group({
      name: [null, [Validators.required]],
      price: [null, [Validators.required]],
    });
  }

  save(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }

    this.product = this.formGroup.value;
    const dataToSave: Product = { ...this.product, company: super.getCompanyCurrentUser(), };

    this.productService.create(dataToSave).pipe()
      .subscribe((product: Product) => {
        this.alertService.success(this.t('kanban.productQuickForm.createSuccess'));
        this.dialogRef.close(product);
      });
  }

  close(): void {
    this.dialogRef.close();
  }

}
